import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['minRange', 'maxRange', 'minInput', 'maxInput', 'output', 'range']
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 500 },
    suffix: { type: String, default: '' }
  }

  connect () {
    this.initializeRanges()
    this.render()
  }

  update (event) {
    let minVal = parseInt(this.minRangeTarget.value, 10)
    let maxVal = parseInt(this.maxRangeTarget.value, 10)

    if (minVal > maxVal) {
      if (event.currentTarget === this.minRangeTarget) {
        maxVal = minVal
        this.maxRangeTarget.value = maxVal
      } else {
        minVal = maxVal
        this.minRangeTarget.value = minVal
      }
    }

    this.syncHiddenInputs(minVal, maxVal)
    this.render(minVal, maxVal)
    this.updateTrack(minVal, maxVal)
  }

  initializeRanges () {
    const minVal = this.initialValue(this.minInputTarget, this.minValue)
    const maxVal = this.initialValue(this.maxInputTarget, this.maxValue)

    this.minRangeTarget.value = minVal
    this.maxRangeTarget.value = maxVal
    this.updateTrack(minVal, maxVal)
  }

  initialValue (inputTarget, fallback) {
    if (!inputTarget || inputTarget.value === '') return fallback

    return parseInt(inputTarget.value, 10)
  }

  syncHiddenInputs (minVal, maxVal) {
    if (!this.hasMinInputTarget || !this.hasMaxInputTarget) return

    this.minInputTarget.value = minVal <= this.minValue ? '' : minVal
    this.maxInputTarget.value = maxVal >= this.maxValue ? '' : maxVal
  }

  render (minVal = null, maxVal = null) {
    if (!this.hasOutputTarget) return

    minVal = minVal ?? parseInt(this.minRangeTarget.value, 10)
    maxVal = maxVal ?? parseInt(this.maxRangeTarget.value, 10)

    this.outputTarget.textContent = `${minVal}${this.suffixValue} – ${maxVal}${this.suffixValue}`
  }

  updateTrack (minVal, maxVal) {
    if (!this.hasRangeTarget) return

    const span = this.maxValue - this.minValue
    const left = ((minVal - this.minValue) / span) * 100
    const width = ((maxVal - minVal) / span) * 100

    this.rangeTarget.style.left = `${left}%`
    this.rangeTarget.style.width = `${width}%`
  }
}
